<template>
  <div>
    <div v-if="isKcomService" class="registration-info">
      <h2 class="c-pageTitle">サービスお申し込み</h2>

      <div class="c-grid">
        <div class="c-grid__items">
          <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
            <div v-if="!plans_loading" class="registration-info__card">
              <div class="registration-info__card__items">
                <div class="registration-info__card__items--title">Googleマップ連携</div>
                <span class="registration-info__card__items--price">{{ meta.smb_pre_store_cost.toLocaleString() }}円</span>
                <span> / </span>
                <span>店舗</span>
                <span> / </span>
                <span>月</span>
              </div>
              <!--
              <div class="registration-info__card__items">
                <div class="registration-info__card__items--title">
                  <span class="registration-info__card__items--titlePlus">+</span>複数媒体連携
                  <span class="registration-info__card__items--option">オプション</span>
                </div>
                <span class="registration-info__card__items--pricePlus">+</span>
                <span class="registration-info__card__items--price">{{ meta.small_plan_optional_cost.toLocaleString() }}</span>
                <span> / </span>
                <span>月</span>
              </div>
              -->
            </div>
            <section class="p-box">
              <Loading v-show="registration_loading" />
              <ValidationObserver v-slot="{ handleSubmit }">
                <form v-show="!registration_loading" class="registration-info__form" @submit.prevent="handleSubmit($event, onSubmit)">
                  <div class="registration-info__form__main">
                    <div class="p-box__body">
                      <h3 class="p-box__title">
                        お申し込みの店舗数を選択してください
                      </h3>
                      <div class="registration-info__form__body registration-info__form__body--border">
                        <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.plan_id" name="お申し込み店舗数" rules="required">
                          <p class="c-formLabel">
                            お申し込み店舗数
                            <span class="registration-info__form__body__description">
                              （必須）
                            </span>
                            <span class="c-error-msg">{{ errors[0] }}</span>
                          </p>
                          <div v-if="!plans_loading" class="registration-info__form__body__select">
                            <Select :class="{'select': isStoreAmountsSelected}" :model-value="value" name="store_amounts" :options="plansByStoreAmounts" @update:model-value="handleChange" />
                            <div class="selectInfo">※６店舗以上の企業様は<a class="u-colorPrimary" :href="allServiceUrlConst['kcom'].contact" target="_blank">こちらから</a>お問い合わせください</div>
                          </div>
                        </ValidationProvider>
                        <Loading v-show="plans_loading" />
                        <!-- KkCheckbox id="multiple" :model-value="isMultipleAlignment" label="複数媒体の連携をする" @change="multipleHandleChange" / -->
                      </div>
                    </div>
                    <div class="p-box__body">
                      <h3 class="p-box__title">
                        アカウント情報を入力してください
                      </h3>
                      <div class="registration-info__form__body registration-info__form__body--border">
                        <div class="registration-info__form__body__form">
                          <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.company.name" name="会社名" rules="required">
                            <p class="c-formLabel">
                              会社名
                              <span class="registration-info__form__body__description">
                                （必須）
                              </span>
                              <span class="c-error-msg">{{ errors[0] }}</span>
                            </p>
                            <TextField :model-value="value" autocomplete="off" name="company[name]" @update:model-value="handleChange" />
                          </ValidationProvider>
                        </div>
                        <div class="registration-info__form__body__form">
                          <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.company.phone_number" name="会社電話番号" rules="required|numeric">
                            <p class="c-formLabel">
                              会社電話番号
                              <span class="registration-info__form__body__description">
                                (必須)
                              </span>
                              <span class="c-error-msg">{{ errors[0] }}</span>
                            </p>
                            <TextField :model-value="value" autocomplete="off" name="company[phone_number]" @update:model-value="handleChange" />
                          </ValidationProvider>
                        </div>
                        <div class="registration-info__form__body__form">
                          <div class="p-userForm__name">
                            <div class="c-grid__item__s__6 c-grid__item__m__6 c-grid__item__l__6">
                              <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.user.last_name" name="姓" rules="required">
                                <p class="c-formLabel">
                                  姓
                                  <span class="registration-info__form__body__description">
                                    （必須）
                                  </span>
                                  <span class="c-error-msg">{{ errors[0] }}</span>
                                </p>
                                <TextField :model-value="value" autocomplete="off" name="user[last_name]" @update:model-value="handleChange" />
                              </ValidationProvider>
                            </div>
                            <div class="c-grid__item__s__6 c-grid__item__m__6 c-grid__item__l__6">
                              <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.user.first_name" name="名" rules="required">
                                <p class="c-formLabel">
                                  名
                                  <span class="registration-info__form__body__description">
                                    （必須）
                                  </span>
                                  <span class="c-error-msg">{{ errors[0] }}</span>
                                </p>
                                <TextField :model-value="value" autocomplete="off" name="user[first_name]" @update:model-value="handleChange" />
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="registration-info__form__body__form">
                          <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.user.email" name="メールアドレス" rules="required|email">
                            <p class="c-formLabel">
                              メールアドレス
                              <span class="registration-info__form__body__description">
                                （必須）
                              </span>
                              <span v-for="error in errors" :key="error" class="c-error-msg">
                                {{ error }}
                              </span>
                            </p>
                            <TextField :model-value="value" autocomplete="off" name="user[email]" @update:model-value="handleChange" />
                          </ValidationProvider>
                        </div>
                        <div class="registration-info__form__body__form">
                          <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.user.password" name="パスワード" rules="required|password">
                            <p class="c-formLabel">
                              パスワード
                              <span class="registration-info__form__body__description">
                                （必須）
                              </span>
                              <span v-for="error in errors" :key="error" class="c-error-msg">
                                {{ error }}
                              </span>
                            </p>
                            <TextField :model-value="value" type="password" autocomplete="off" name="user[password]" @update:model-value="handleChange" />
                          </ValidationProvider>
                        </div>
                        <div class="registration-info__form__body__form">
                          <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="registration.user.password_confirmation" name="パスワード確認" :rules="`required|confirmed:${registration.user.password}`">
                            <p class="c-formLabel">
                              パスワード確認
                              <span class="registration-info__form__body__description">
                                （必須）
                              </span>
                              <span v-for="error in errors" :key="error" class="c-error-msg">
                                {{ error }}
                              </span>
                            </p>
                            <TextField :model-value="value" type="password" autocomplete="off" name="user[password_confirmation]" @update:model-value="handleChange" />
                          </ValidationProvider>
                        </div>
                        <div class="registration-info__form__body__form">
                          <p class="c-formLabel">
                            代理店コード
                            <span class="registration-info__form__body__description">
                              （お持ちの方）
                            </span>
                          </p>
                          <TextField :model-value="registration.company.agency_code.value" autocomplete="off" name="company[agency_code]" @update:model-value="registration.company.agency_code.value = $event" />
                        </div>
                      </div>
                    </div>
                    <div class="p-box__body">
                      <h3 class="p-box__title">
                        お支払い情報を入力してください
                      </h3>
                      <div class="registration-info__form__body">
                        <div ref="scriptHolder" />
                      </div>
                    </div>
                  </div>
                  <div v-if="isStoreAmountsSelected" class="registration-info__form__price-board">
                    <h3 class="registration-info__form__price-board__title">
                      お支払い内容
                    </h3>
                    <div class="c-price">
                      <p>お申し込み店舗数：</p>
                      <p class="u-fwB">{{ selectedStoreAmount.toLocaleString() }}店舗</p>
                    </div>
                    <div class="c-price">
                      <p>お申し込み店舗数分（年払い）：</p>
                      <p class="u-fwB">{{ annualStoreNumberPrice.toLocaleString() }}円</p>
                    </div>
                    <div v-show="isMultipleAlignment" class="c-price">
                      <p>複数媒体連携オプション（年払い）：</p>
                      <p class="u-fwB">{{ annualSmallPlanOptionalPrice.toLocaleString() }}円</p>
                    </div>
                    <div class="c-price discount-price">
                      <p>初月無料分：</p>
                      <p class="u-fwB">-{{ firstMonthDiscountAmount.toLocaleString() }}円</p>
                    </div>
                    <div class="c-price">
                      <p>消費税：</p>
                      <p class="u-fwB">{{ totalTax.toLocaleString() }}円</p>
                    </div>
                    <div class="registration-info__form__price-board__bottom">
                      <div class="c-total-price">
                        <p class="u-fwB">ご請求額合計：</p>
                        <p class="u-fwB u-colorPrimary">{{ totalPrice.toLocaleString() }}円</p>
                      </div>
                      <p class="c-checkbox__item c-registration-check u-pad0">
                        <input id="checkbox1" v-model="hasGmbAccount" class="c-checkbox__input" type="checkbox">
                        <label class="c-checkbox__label c-agreement" for="checkbox1">
                          Google マップのアカウントを持っています
                        </label>
                      </p>
                      <p class="c-checkbox__item c-registration-check u-pad0">
                        <input id="checkbox2" v-model="isAgreeTerm" class="c-checkbox__input" type="checkbox">
                        <label class="c-checkbox__label c-agreement" for="checkbox2">
                          <span class="c-links__item u-pad0">
                            <a :href="allServiceUrlConst['kcom'].terms" target="_blank">
                              本サービス利用規約
                            </a>
                          </span>
                          と
                          <span class="c-links__item u-pad0" @click="showClauseModal">
                            <a>ご契約条項</a>
                          </span>
                          に同意します
                        </label>
                      </p>
                      <button :disabled="!isAllAgree" :class="registerBtnStyle" type="submit">
                        お支払いを確定して申し込む
                      </button>
                      <p>※お支払いは年払いのみとなります</p>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </section>
          </div>
        </div>
      </div>
      <ClauseModal v-show="showClause" @close="showClause = !showClause" />
    </div>
    <Page403 v-else />
  </div>
</template>

<script>
import Select from '../components/Select'
import TextField from '../components/TextField'
import Loading from '../components/Loading.vue'
import Page403 from '../components/Page403.vue'
import ClauseModal from '../components/RegistrationsInfo/ClauseModal'
import { allServiceUrlConst } from '../modules/serviceUrlConst'
import {mapActions, mapState} from 'vuex'
import { KCOM_URLS } from '../modules/urls'
export default {
  name: 'RegistrationsInfo',
  components: {
    TextField,
    Select,
    Loading,
    ClauseModal,
    Page403,
  },
  data() {
    return {
      settingsPayjpPublicKey: gon.settingsPayjpPublicKey,
      isAgreeTerm: false,
      hasGmbAccount: false,
      showClause: false,
      isMultipleAlignment: false,
    }
  },
  computed: {
    ...mapState({
      plans: state => state.plans.data,
      meta: state => state.plans.meta,
      plans_loading: state => state.plans.loading,
      registration: state => state.companiesRegistrationsInfo.data,
      registration_loading: state => state.companiesRegistrationsInfo.loading,
    }),
    allServiceUrlConst: () => allServiceUrlConst,
    isAllAgree() {
      return this.isAgreeTerm && this.hasGmbAccount
    },
    selectedPlanId() {
      return this.registration.plan_id
    },
    registerBtnStyle() {
      return {
        'c-button__item c-registration-button': true,
        'c-button__item--outline-primary': this.isAllAgree,
        'c-button__item--disabled': !this.isAllAgree
      }
    },
    isStoreAmountsSelected() {
      return this.selectedPlanId !== null
    },
    plansByStoreAmounts() {
      let currentSelectedIndex = 0
      let kindPlan = this.isMultipleAlignment ? 'small' : 'entry'
      if(this.registration.plan_id) {
        currentSelectedIndex = Object.keys(this.plansByStoreAmounts).find((key) => this.plansByStoreAmounts[key] === Number(this.registration.plan_id))
      }
      let plansByStoreAmountsList = {}
      const plansFilter = this.plans.filter(v => v.kind === kindPlan)
      plansFilter.forEach(v =>{
        plansByStoreAmountsList[this.formatStoreAmounts(v)] = v.id
      })
      if(this.registration.plan_id) {
        this.changeSelectedPlanId(plansByStoreAmountsList[currentSelectedIndex])
      }
      return plansByStoreAmountsList
    },
    selectedPlan() {
      return this.plans.find(v => v.id === Number(this.selectedPlanId))
    },
    selectedStoreAmount() {
      return this.formatStoreAmounts(this.selectedPlan)
    },
    annualPrice() {
      return Number(this.selectedPlan.annual_cost_amount)
    },
    annualSmallPlanOptionalPrice() {
      return this.meta.small_plan_optional_cost * 12
    },
    annualStoreNumberPrice() {
      if(this.isMultipleAlignment) return this.annualPrice - this.annualSmallPlanOptionalPrice
      return this.annualPrice
    },
    firstMonthDiscountAmount() {
      return Number(this.selectedPlan.first_month_discount_amount)
    },
    totalTax() {
      return this.selectedPlan.total_tax_amount
    },
    totalPrice() {
      return this.annualPrice + this.totalTax - this.firstMonthDiscountAmount
    },
    isKcomService() {
      return KCOM_URLS.some(url => document.domain.includes(url))
    }
  },
  created() {
    this.readPlans()
    const agency_code = this.$route.query.agency_code
    if(agency_code) {
      this.initCompanyAgencyCode(agency_code)
    }
  },
  mounted() {
    if(!this.$refs.scriptHolder) return
    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', 'https://checkout.pay.jp/')
    scriptEl.setAttribute('class', 'payjp-button')
    scriptEl.setAttribute('data-partial', 'true')
    // public key
    scriptEl.setAttribute('data-key', this.settingsPayjpPublicKey)
    this.$refs.scriptHolder.appendChild(scriptEl)
  },
  methods: {
    ...mapActions({
      readPlans: 'plans/readPlans',
      writeRegistrationsInfo: 'companiesRegistrationsInfo/writeRegistrationsInfo',
      initPlanId: 'companiesRegistrationsInfo/initPlanId',
      changePlanId: 'companiesRegistrationsInfo/changePlanId',
      initCompanyAgencyCode: 'companiesRegistrationsInfo/initCompanyAgencyCode'
    }),
    async onSubmit() {
      const isSuccess = await this.writeRegistrationsInfo()
      if (isSuccess) this.$router.push({ name: 'RegistrationsApplyCompleted'})
    },
    formatStoreAmounts(amount) {
      return amount.max_store_count === amount.min_store_count
        ? amount.max_store_count
        : amount.min_store_count + ' 〜 ' + amount.max_store_count
    },
    showClauseModal() {
      this.showClause = true
      this.isAgreeTerm = !this.isAgreeTerm
    },
    multipleHandleChange() {
      this.isMultipleAlignment = !this.isMultipleAlignment
    },
    changeSelectedPlanId(currentSelectedId) {
      this.changePlanId(currentSelectedId)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../stylesheets/biz_spa/foundation/_mixin.scss';
.registration-info {
  @include mq(lg) {
    margin: 0 124px;
  }
  &__card {
    display: flex;
    justify-content: flex-start;
    &__items {
      border-radius: 4px;
      box-shadow: 0 0 0 rgb(63 63 68 / 5%);
      background: #FFF;
      margin-right: 24px;
      padding: 32px 27px 32px 32px;
      font-size: 18px;
      @media screen and (max-width: #{ map-get($breakpoints, sm) }px) {
        padding: 10px;
        margin: auto;
      }
      &--title {
        font-size: 12px;
      }
      &--price {
        font-weight: bold;
      }
      &--titlePlus {
        margin-right: 5px;
      }
      &--pricePlus {
        margin-right: 5px;
        font-weight: bold;
      }
      &--option {
        font-size: 10px;
        border-radius: 12px;
        background-color: #E9446A;
        color: #fff;
        padding: 5px;
        font-weight: bold;
      }
    }
  }
  &__form {
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: #{ map-get($breakpoints, sm) }px) {
      flex-wrap: wrap;
    }
    &__main {
      width: 596px;
      &__store-amounts {
        border-bottom: 1px solid #E4E7EB;
        box-sizing: border-box
      }
    }
    &__price-board {
      width: 405px;
      font-size: 14px;
      padding: 24px;
      margin: 32px 16px;
      border: 1px solid #E4E7EB;
      border-radius: 4px;
      @include mq(md) {
        margin: 32px 32px 779px 32px;
      }
      &__title {
        font-size: 14px;
      }
      &__bottom {
        font-size: 12px;
        text-align: center;
        border-top: 1px solid #E4E7EB;
      }
    }
    &__body  {
      padding-top: 32px;
      padding-bottom: 32px;
      &--border {
        border-bottom: 1px solid #E4E7EB;
      }
      &__form {
        margin-bottom: 32px;
      }
      &__description {
        font-weight: normal;
        font-size: 10px;
      }
      &__select {
        display: flex;
        align-items: flex-end;
        margin-bottom: 16px;
        @media screen and (max-width: #{ map-get($breakpoints, sm) }px) {
          display: block;
        }
      }
    }
  }
}
.select {
  width: 25%;
  @media screen and (max-width: #{ map-get($breakpoints, sm) }px) {
    width: 100%;
  }
}
.selectInfo {
  font-size: 12px;
  margin-left: 16px;
  @media screen and (max-width: #{ map-get($breakpoints, sm) }px) {
    margin-left: 0;
  }
}
.c-price {
  display: flex;
  justify-content: space-between;
  margin: 24px auto;
}
.c-total-price {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  margin: 24px auto;
}
.c-agreement {
  font-size: 12px;
  span {
    font-size: 12px !important;
  }
}
.c-registration-button {
  margin: 16px auto;
}
.c-registration-check {
  margin-top: 16px;
  margin-bottom: 15px;
}
.c-error-wrapper {
  margin-left: 5px;
}
.discount-price {
  color: $color-accent-primary;
}
</style>
